import dayjs from 'dayjs';
import { getMatchingOriginProp } from "./prop";
export const transformCondition = () => {};
export const transformGroupBy = (groupBy, groupOption, template) => {};
export const transformViewOption = {
  condition: transformCondition,
  groupBy: transformGroupBy,
  orderByKey: () => {}
};

// 属性的数据转换
export const transformViewOptionPropData = (template, propIndex, propInfo, conditionValue, brotherNodeProp) => {
  let value = conditionValue;
  // 筛选值只取1个
  // 属性有默认值，并且筛选值不包含默认值，取筛选值第一个
  // 属性有默认值，并且筛选项包含默认值，取默认值
  // 属性没有默认值，取第一个

  // 数字属性 取上一个（在视图上已存在的节点）节点的值
  // 公式属性，取上一个节点的 计算源 的值
  const isNumberProp = propInfo.type === 'number';
  const isFormulaProp = propInfo.type === 'formula';
  if (isNumberProp) {
    value = brotherNodeProp[propIndex];
    return [{
      value,
      propIndex
    }];
  } else if (isFormulaProp) {
    const correlationIndex = getFormulaCorrelationIndex(propInfo.formula);
    return correlationIndex.map(index => ({
      propIndex: index,
      value: brotherNodeProp[propIndex]
    }));
  } else if (propInfo.type === 'cascade') {
    return [{
      value,
      propIndex
    }];
  } else {
    const propDefaultValue = template.prop?.[propIndex]?.defaultValue;
    if (propDefaultValue !== undefined && propDefaultValue !== null) {
      const conditionValueHasPropDefaultValue = ~conditionValue.indexOf(propDefaultValue);
      if (!conditionValueHasPropDefaultValue) {
        value = value.length ? [value[0]] : [];
      } else {
        value = [propDefaultValue];
      }
    } else {
      value = value.length ? [value[0]] : [];
    }
    if (!propInfo.multiple) {
      value = value.length ? value[0] : null;
    }
    return [{
      value,
      propIndex
    }];
  }
};

// formulaConfig: input:[],op:''
const getFormulaCorrelationIndex = formulaConfig => {
  let indexes = new Set();
  formulaConfig.input.map(x => {
    if (x.type === 'formula') {
      getFormulaCorrelationIndex(x.formula).map(i => indexes.add(i));
    } else {
      indexes.add(x.prop);
    }
  });
  return Array.from(indexes);
};

/**
 * 获取所有children的筛选条件 筛选组 排序条件
 * 1. 系统字段: 创建人，创建时间，修改时间
 * 3. 模板属性
 * 4. 模板状态
 * 5. 模板状态属性
 */
// 过滤条件 1. 系统字段：创建人,创建时间,修改时间  3. 模板属性 4. 模板状态 5. 模板状态属性
// 排序 1. 系统字段里的时间 创建/修改 2. 模板属性的时间类型 3. 模板状态属性的时间类型
// 分组 1. 模板属性、模板状态属性 里的枚举属性/单选人员 2. 状态
export const getViewSettingOptionWithGroup = (templateList, orgInfo, tempMap = {}, quoteOptions = {}) => {
  // 空间权限
  const orgRoles = [...orgInfo.groupList];
  if (orgInfo.role === 1 || orgInfo.role === 3) {
    orgRoles.push('-2');
  }
  // 筛选条件项
  const option = {
    // 系统属性
    _sys_creator: {
      name: '创建者',
      options: new Set(),
      type: 'user'
    },
    _sys_createTime: {
      name: '创建时间',
      options: new Set(),
      type: 'date'
    },
    _sys_tag: {
      name: '标签',
      options: new Set(),
      type: 'tag'
    },
    // 模板状态
    templateStatus: {
      name: '状态',
      options: []
    }
    // 历史状态
    /*historyStatus: {
        name: '历史状态',
        options: [],
      },*/
    // 状态流转
    // statusFlow: {
    //   name: '状态流转',
    //   options: [],
    // },
    // 模板属性
    // 模板状态属性
  };

  // 筛选条件项分组
  const optionGroup = {
    sys: new Set(['_sys_creator', '_sys_createTime', '_sys_tag']),
    templateStatus: new Set(['templateStatus'
    // 'statusFlow'
    ]),
    templateProp: new Set(),
    templateStatusProp: new Set()
  };
  const optionGroupKeyMap = {
    sys: '系统属性',
    templateStatus: '状态相关',
    // statusFlow: '状态流转',
    templateProp: '属性',
    templateStatusProp: '状态属性'
  };

  // 排序项
  const orderByOption = {
    _sys_createTime: {
      name: '创建时间'
    },
    templateStatus: {
      name: '状态'
    },
    treeLevel: {
      name: '主题树顺序'
    },
    _sys_updateTime: {
      name: '更新时间'
    }
  };

  // 分组项
  let groupOption = {
    sysCreator: {
      name: '创建人'
    },
    _sys_tag: {
      name: '标签'
    },
    // 模板状态属性前两个为固定
    templateStatusPropBase_0: {
      name: '负责人'
    },
    templateStatus: {
      name: '当前状态'
    },
    dayHours: {
      name: '开始时间'
    }
  };
  if (templateList.length === 0) groupOption = {
    template: {
      name: '主题类型'
    }
  };
  templateList?.map(template => {
    const statusOptions = [];
    // 模板属性
    const optionGroupTemplateProp = [];
    template.prop.map((prop, propIndex) => {
      if (!prop || !prop.type
      // || prop.hide
      ) return;

      // 时间属性 prop.dateFormat HH:mm 隐藏
      if (prop.type === 'date' || prop.type === 'datetime') {
        if (prop.dateFormat === 'HH:mm') {
          return;
        }
      }
      let auth = false;
      const visGroups = prop.visGroups || ['-1'];
      if (visGroups.includes('-1')) {
        auth = true;
      } else {
        visGroups.map(item => {
          if (orgRoles.includes(item)) {
            auth = true;
          }
        });
      }
      if (!auth) return;
      const key = `templateProp_${template.template_id}_${propIndex}`;
      const optionSet = new Set();
      if (prop.type === 'enum' || prop.type === 'tag') {
        if (Array.isArray(prop.extend) && prop.extend.length) {
          prop.extend.filter(i => typeof i === 'string').forEach(e => {
            if (e && !optionSet.has(e)) optionSet.add(e);
          });
        }
        if (quoteOptions[propIndex]) {
          quoteOptions[propIndex].forEach(e => {
            if (e && !optionSet.has(e)) optionSet.add(e);
          });
        }
      }
      option[key] = {
        name: prop.name,
        options: optionSet,
        type: prop.type,
        data: prop
      };
      optionGroupTemplateProp.push({
        key,
        sort: prop.sort
      });
      if (prop.type === 'date' || prop.type === 'datetime' || prop.type === 'enum' || prop.type === 'number' || prop.type === 'auto_inc' || prop.type === 'formula' && prop.formulaFormat === 0) {
        orderByOption[key] = {
          name: prop.name
        };
      }
      if (prop.type === 'user' || prop.type === 'enum' || prop.type === 'tag' || prop.type === 'number' ||
      // prop.type === 'cascade' ||
      prop.type === 'text' || prop.type === 'formula'
      // ||
      // prop.type === 'address'
      ) {
        groupOption[key] = {
          name: prop.name,
          data: prop
        };
      }
      if (prop.type === 'quote') {
        const originalProp = getMatchingOriginProp(prop, tempMap);
        if (originalProp && typeof originalProp === 'object' && (originalProp.type === 'enum' && ('quoteTempId' in originalProp ? !originalProp.quoteTempId : true) || originalProp.type === 'tag' || originalProp.type === 'text' || originalProp.type === 'formula' || originalProp.type === 'user')) {
          groupOption[key] = {
            name: prop.name,
            data: prop
          };
        }

        // 如果存在选值，加进去！
        // 例如：引用了选值属性，文本，状态
        if (quoteOptions[propIndex]) {
          quoteOptions[propIndex].forEach(e => {
            if (e && !optionSet.has(e)) optionSet.add(e);
          });
        }
      }
    });
    optionGroup.templateProp = new Set(optionGroupTemplateProp.sort((a, b) => a.sort - b.sort).map(x => x.key));

    // 模板状态
    template.task_status.map((task, taskIndex) => {
      if (!task?.name || task.delete) return;
      statusOptions.push({
        key: `${template.template_id}_${taskIndex}`,
        name: task.name,
        sort: 'sort' in task ? task.sort : taskIndex
      });

      // 模板状态属性
      task.prop.map((prop, propIndex) => {
        // 关联属性是{index：number}
        if (!prop?.type || prop.type === 'quote') return;
        // 区分基础模板状态属性和模板自定义状态属性
        // 基础属性 [负责人,参与者,开始时间,结束时间,备注]
        // let propKey;
        const propKey = `templateStatusPropBase_${propIndex}`;
        // if (propIndex <= 4) {
        //   propKey = `templateStatusPropBase_${propIndex}`;
        // } else {
        //   propKey = `templateStatusPropCustom_${template.template_id}_${taskIndex}_${propIndex}`;
        // }
        option[propKey] = {
          name: prop.name,
          options: new Set(),
          type: prop.type,
          data: prop
        };
        optionGroup.templateStatusProp.add(propKey);
        if (prop.type === 'datetime') {
          orderByOption[propKey] = {
            name: prop.name
          };
        }
        if (prop.type === 'user') {
          let name = '';
          // 模板状态属性前五位固定 负责人,参与者，开始时间，结束时间，备注
          if (propIndex <= 4) {
            if (propIndex === 0) {
              name = '负责人';
            } else if (propIndex === 1) {
              name = '参与者';
            }
          } else {
            name = prop.name;
          }
          groupOption[propKey] = {
            name: name,
            data: prop
          };
        }
      });
    });
    if (statusOptions.length) {
      statusOptions.sort((b, a) => b.sort - a.sort);
      option.templateStatus.options.push.apply(option.templateStatus.options, statusOptions);
      // option.historyStatus.options.push.apply(option.historyStatus.options, statusOptions);
    }
  });

  // 增加 负责人 或 参与者 筛选条件
  option.templateStatusOwnerAndParticipant = {
    name: '负责人或参与者',
    type: 'user',
    data: {
      multiple: true,
      name: '负责人或参与者',
      required: false,
      type: 'user'
    },
    options: []
  };
  optionGroup.templateStatusProp.add('templateStatusOwnerAndParticipant');
  if (templateList.length) groupOption['templateStatusOwnerAndParticipant'] = {
    name: '负责人或参与者',
    data: {
      multiple: true,
      name: '负责人或参与者',
      required: false,
      type: 'user'
    }
  };

  // set 转数组再输出
  const resOption = {};
  Object.keys(option).map(x => {
    resOption[x] = {
      ...option[x],
      options: Array.from(option[x].options)
    };
  });
  const resOptionGroup = {};
  Object.keys(optionGroup).map(x => {
    resOptionGroup[x] = Array.from(optionGroup[x]);
  });
  Object.keys(groupOption).map(x => {
    switch (groupOption[x].data?.type) {
      case 'user':
        groupOption[x].subMenu = [{
          name: '按成员',
          key: x.concat('_0')
        }, {
          name: '按成员组',
          key: x.concat('_1')
        }];
        break;
      case 'cascade':
        if (groupOption[x].data.cascade) {
          groupOption[x].subMenu = Array.from({
            length: groupOption[x].data.cascade.titles.length
          }, (v, i) => {
            return {
              name: `第${i + 1}级`,
              key: x.concat('_', (i + 1).toString())
            };
          });
        }
        break;
      case 'address':
        const subMenus = [{
          name: '省份',
          key: x.concat('_', 'province')
        }];
        if (groupOption[x].data.accuracy !== 'province') {
          subMenus.push({
            name: '省份/城市',
            key: x.concat('_', 'city')
          });
          if (groupOption[x].data.accuracy !== 'city') {
            subMenus.push({
              name: '省份/城市/区县',
              key: x.concat('_', 'district')
            });
            if (groupOption[x].data.accuracy !== 'district') {
              subMenus.push({
                name: '省份/城市/区县/街道',
                key: x.concat('_', 'street')
              });
            }
          }
        }
        groupOption[x].subMenu = subMenus;
        break;
    }
  });
  const fieldOptionGroup = Object.keys(resOptionGroup).reduce((a, groupKey) => {
    a[groupKey] = {
      name: optionGroupKeyMap[groupKey],
      optionKeys: resOptionGroup[groupKey]
    };
    return a;
  }, {});
  return {
    option: resOption,
    optionGroup: resOptionGroup,
    fieldOptionGroup,
    optionGroupKeyMap,
    orderByOption,
    groupOption
  };
};

/**
 * 视图配置 转成 后端（中间件和接口）的筛选器的数据结构
 */
export const convertViewConfigToFilterConfig = () => {
  // TODO
};
export const fixConditionV2ToFilterConfig = (conditionV2, userId) => {
  if (conditionV2 && conditionV2.length && conditionV2.length >= 2) {
    conditionV2 = conditionV2.map((x, i) => {
      if (x.key === 'templateId' || x.key === 'ancestor') {
        x.op = 'intersect';
      } else if (i === 0 || i === 1 || x.key === 'status') {
        x.op = 'intersect';
      } else if (i > 1 && x.op === 'timeBein' && (x.input.length > 2 || x.input[0] === x.input[1])) {
        if (x.input.length > 2) {
          //近几日
          const endTime = dayjs(dayjs().format('YYYY/MM/DD') + ' 23:59:59').valueOf();
          const startTime = endTime - (Number(x.input[2]) + 1) * 24 * 60 * 60 * 1000 + 1000;
          x.input = [startTime, endTime];
        } else {
          //开始结束时间
          const startTime = dayjs(dayjs(x.input[0]).format('YYYY/MM/DD') + ' 00:00:00').valueOf();
          const endTime = dayjs(dayjs(x.input[0]).format('YYYY/MM/DD') + ' 23:59:59').valueOf();
          x.input = [startTime, endTime];
        }
      } else if (x?.extends?.type === 'text') {
        x.op = 'textInclude';
      } else if (x?.extends?.type === 'user' && x.input.length === 1 && x.input[0] === null) {
        x.input = [userId];
      } else if (x.key === 'sysCreator' || x.key === 'statusProp' && (x.index === 0 || x.index === 1) || x.key === 'templateStatusOwnerAndParticipant') {
        if (Array.isArray(x.input)) {
          x.input = x.input.map(y => y === null ? userId : y);
        } else {
          x.input = x.input === null ? userId : x.input;
        }
      }
      return x;
    });
  }
  return conditionV2;
};